export default {
  modalTitle: {
    id: 'product_jp_verified_refurbished_modal_title',
    defaultMessage: 'Verified refurbish',
  },
  checkpointsTitle: {
    id: 'product_jp_verified_refurbished_modal_checkpoints_title',
    defaultMessage: 'Verified by Back Market,',
  },
  checkpointsSubTitle: {
    id: 'product_jp_verified_refurbished_modal_checkpoints_sub_title',
    defaultMessage: 'Top quality refurbish',
  },
  checkpointsDescription: {
    id: 'product_jp_verified_refurbished_modal_checkpoints_description',
    defaultMessage:
      "At Back Market, we offer only the highest-quality refurbished products, all of which undergo over 28 rigorous quality checks to ensure they meet industry-leading standards. Only sellers who pass Back Market's strict quality requirements are allowed to sell on our platform. Plus, every purchase comes with a free 1-year warranty, so you can shop with confidence knowing you're covered in case of any issues.",
  },
  differenceVsUsedTitle: {
    id: 'product_jp_verified_refurbished_modal_difference_vs_used_title',
    defaultMessage: 'Difference vs. Used',
  },
  differenceVsUsedDescription: {
    id: 'product_jp_verified_refurbished_modal_difference_vs_used_description',
    defaultMessage:
      "Refurbished products, also known as 'seibihin,' are originally used items that are collected and then carefully inspected, repaired, and cleaned by experts. After this process, they are tested to ensure they meet high standards and are ready for a second life as refurbished products. Plus, with Back Market, you get a comprehensive warranty, so you can use your device with peace of mind.",
  },
  vsUsedTitle: {
    id: 'product_jp_verified_refurbished_modal_vs_used_title',
    defaultMessage: 'Used',
  },
  vsUsedState: {
    id: 'product_jp_verified_refurbished_modal_vs_used_state',
    defaultMessage: 'Used items that are resold as-is',
  },
  vsUsedRepairState: {
    id: 'product_jp_verified_refurbished_modal_vs_used_repair_state',
    defaultMessage: 'Often shows signs of wear and tear or scratches',
  },
  vsUsedWarranty: {
    id: 'product_jp_verified_refurbished_modal_vs_used_warranty',
    defaultMessage: 'No warranty or a short-term warranty',
  },
  vsUsedBattery: {
    id: 'product_jp_verified_refurbished_modal_vs_used_battery',
    defaultMessage: 'No battery capacity warranty',
  },
  vsRefurbishedTitle: {
    id: 'product_jp_verified_refurbished_modal_vs_refurbished_title',
    defaultMessage: 'Refurbished',
  },
  vsRefurbishedState: {
    id: 'product_jp_verified_refurbished_modal_vs_refurbished_state',
    defaultMessage:
      'Pre-owned items that have been repaired and refurbished by experts ✅',
  },
  vsRefurbishedRepairState: {
    id: 'product_jp_verified_refurbished_modal_vs_refurbished_repair_state',
    defaultMessage:
      'Inspected, repaired, cleaned, and tested for functionality ✅',
  },
  vsRefurbishedWarranty: {
    id: 'product_jp_verified_refurbished_modal_vs_refurbished_warranty',
    defaultMessage: 'Comes with warranty ✅',
  },
  vsRefurbishedBattery: {
    id: 'product_jp_verified_refurbished_modal_vs_refurbished_battery',
    defaultMessage: '80~100%',
  },
}
